export default "__VITE_ASSET__DSRHu4SB__"